<section id="about" class="about section">
  <div class="container section-title" data-aos="fade-up">
    <h2>About<span> All-In-One Invoice</span></h2>
    <p>Who We Are</p>
  </div>

  <div class="container">
    <div class="row gy-4">
      <div class="col-lg-6 content" data-aos="fade-up" data-aos-delay="100">
        <!-- <p class="who-we-are">Who We Are</p> -->
        <h3>Our Mission</h3>
        <p class="fst-italic">
          We believe that invoicing should be simple, fast, and accessible to everyone. All-In-One Invoice was created
          to help small businesses, freelancers, and entrepreneurs focus on what matters most - their business.
        </p>

        <h3>Our Story</h3>
        <p>Founded in 2023, All-In-One Invoice has been helping thousands of users manage their invoicing with ease. Our
          team is dedicated to providing the best user experience and continuously improving our platform.</p>

        <h3>Why We're Different</h3>
        <ul>
          <li>
            <i class="bi bi-check-circle"></i>
            <span>User-friendly interface that requires no training</span>
          </li>
          <li>
            <i class="bi bi-check-circle"></i>
            <span>Professional templates designed by experts</span>
          </li>
          <li>
            <i class="bi bi-check-circle"></i>
            <span>Secure cloud storage options for all your invoices</span>
          </li>
          <li>
            <i class="bi bi-check-circle"></i>
            <span>Fast and reliable support team</span>
          </li>
          <li>
            <i class="bi bi-check-circle"></i>
            <span>Affordable pricing for all business sizes</span>
          </li>
        </ul>

        <h3>Our Values</h3>
        <ul>
          <li>
            <i class="bi bi-check-circle"></i>
            <span>
              <strong>Simplicity:</strong> Making invoicing easy for everyone
            </span>
          </li>
          <li>
            <i class="bi bi-check-circle"></i>
            <span>
              <strong>Reliability:</strong> Ensuring your data is always safe
            </span>
          </li>
          <li>
            <i class="bi bi-check-circle"></i>
            <span>
              <strong>Innovation:</strong> Constantly improving our platform
            </span>
          </li>
          <li>
            <i class="bi bi-check-circle"></i>
            <span>
              <strong>Support:</strong> Being here when you need us
            </span>
          </li>
        </ul>
        <a [routerLink]="['/contact']" class="read-more"><span>Contact Us</span><i class="bi bi-arrow-right"></i></a>
      </div>

      <div class="col-lg-6 about-images" data-aos="fade-up" data-aos-delay="200">
        <div class="row gy-4">
          <!-- <div class="col-lg-6">
                        <img src="assets/img/mine/about-company-1.png" class="img-fluid" alt="">
                    </div> -->
          <div>
            <div class="row gy-4">
              <div class="col-lg-12">
                <img src="/img/mine/about-company-2.svg" class="img-fluid" alt="">
              </div>
              <!-- <div class="col-lg-12">
                                <img src="assets/img/mine/about-company-3.svg" class="img-fluid" alt="">
                            </div> -->
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</section>